import { ISettingsAdapter } from '#/components/chart/external/charting_library';
import { throttle } from '#/lib/throttle';

import { getChartOverrides } from '../chartSettings';

const LOCAL_STORAGE_ID = 'katanap_chart_settings_v1';

/** To be removed from local storage */
let OLD_LOCAL_STORAGE_IDS = ['kuma_chart_settings_v3'];

type StoredSettingsMap = { [key: string]: string };

export const resetChartSettings = () => {
  // Clean local storage
  localStorage.removeItem(LOCAL_STORAGE_ID);
  // But also remove all from settings in RAM
  // Remove all settings from MAP
  Object.keys(cachedSettingsMap || {}).forEach(function (key) {
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete cachedSettingsMap[key];
  });
};

export const loadChartSettings = (): StoredSettingsMap | undefined => {
  // Wipe previous one from storage (Note: settings can be large)
  OLD_LOCAL_STORAGE_IDS.forEach(id => localStorage.removeItem(id));
  OLD_LOCAL_STORAGE_IDS = [];

  const settingsAsText = localStorage.getItem(LOCAL_STORAGE_ID);
  if (!settingsAsText) {
    return;
  }
  try {
    const settings = JSON.parse(settingsAsText);
    return settings;
  } catch (error) {
    console.warn(error);
    console.warn('Cannot initialize CHART settings');
  }
};

const cachedSettingsMap: StoredSettingsMap = loadChartSettings() || {};

const saveData = () => {
  console.log('[Chart_settings] Saving...');
  localStorage.setItem(LOCAL_STORAGE_ID, JSON.stringify(cachedSettingsMap));
};
const saveThrottledBySecond = throttle(saveData, 1000);

const overridesMap = getChartOverrides(true);

// const applyOverride = <T extends keyof typeof overridesMap>(value: T) => {
//   cachedSettingsMap[value] = overridesMap[value];
// };

export const settingsAdapter: ISettingsAdapter = {
  initialSettings: cachedSettingsMap,
  // Note: some settings seems not to be loaded
  //  https://github.com/tradingview/charting_library/issues/5377
  //  {
  //   'ChartDrawingToolbarWidget.visible': "false",
  // },

  setValue: (key, value) => {
    console.debug('[Chart_settings] SET', key);
    // console.debug('[Chart_settings] SET value:', value);
    // There is a bug that overriden properties are not properly stored initially
    if (key === 'chartproperties') {
      cachedSettingsMap[key] = value
        .replace(
          '"backgroundGradientStartColor":"#181C27"',
          `"backgroundGradientStartColor":"${overridesMap['paneProperties.backgroundGradientStartColor']}"`
        )
        .replace(
          '"backgroundGradientEndColor":"#131722"',
          `"backgroundGradientEndColor":"${overridesMap['paneProperties.backgroundGradientEndColor']}"`
        );
      // .replace(
      //   '"upColor":"#00bc8a"',
      //   `"upColor":"${overridesMap['mainSeriesProperties.candleStyle.upColor']}"'`
      // )
      // .replace(
      //   '"downColor":"#ee3f3f"',
      //   `"downColor":"${overridesMap['mainSeriesProperties.candleStyle.downColor']}"'`
      // );
    } else {
      cachedSettingsMap[key] = value;
    }
    // There is a bug which will reset those, so make sure user is not able to save those values
    // Bug is reproducible by resizing chart to mobile/or desktop and refreshing page
    // applyOverride('paneProperties.background');
    // applyOverride('paneProperties.backgroundGradientEndColor');
    // applyOverride('paneProperties.backgroundGradientStartColor');
    // applyOverride('paneProperties.backgroundType');

    saveThrottledBySecond();
  },
  removeValue: key => {
    console.debug('[Chart_settings] REMOVE', key);
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete cachedSettingsMap[key];

    // cachedSettingsMap['paneProperties.background'] = '#000';
    // cachedSettingsMap['paneProperties.backgroundGradientEndColor'] = '#000';
    // cachedSettingsMap['paneProperties.backgroundGradientStartColor'] = '#000';
    // cachedSettingsMap['paneProperties.backgroundType'] = 'solid';

    saveThrottledBySecond();
  },
};
